import React, { memo } from 'react';
import { Brain, Check, AlertTriangle, Clock, Target, Zap, BookOpen, Users, ShieldCheck, Shield } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { ImageCarousel } from '../components/ImageCarousel';
import { CountdownTimer } from '../components/CountdownTimer';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45711849652385:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/xeeyEkbrnyJDmAbLpp3jSa/MOCKUP_gimnasia_cerebral_infantil.png';
const BONO1_IMAGE = 'https://cdn.magicpatterns.com/uploads/4JHzAbAuXPjV7eq6DSgZ8w/ChatGPT_Image_9_feb_2026,_11_20_17_p.m..png';
const BONO2_IMAGE = 'https://cdn.magicpatterns.com/uploads/k387Yvpic8ZQpfRjn2HDHw/ChatGPT_Image_9_feb_2026,_11_29_27_p.m..png';
const BONO3_IMAGE = 'https://cdn.magicpatterns.com/uploads/473hp7nbK2DjVAUwa3BJQz/ChatGPT_Image_9_feb_2026,_11_41_00_p.m..png';
const CAROUSEL_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/tSxSeVETp6tnBCD8ELz2ps/Modulo-1.png',
  alt: 'Módulo 1 - Activación de la Atención'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iCT6AjLCzddMP3d58aXg1X/Ejercicio-Completar-Patrones-Simples.png',
  alt: 'Ejercicio - Completar Patrones Simples'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mwaTkXY65dztrmSg9C8Njk/Ejercicio-Completar-Patrones-Avanzados.png',
  alt: 'Ejercicio - Completar Patrones Avanzados'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r8kkdeSeGZjKHzgjVs5sNM/Ejercicio-Ordenar-Secuencia-de-Rutina-Diaria.png',
  alt: 'Ejercicio - Ordenar Secuencia de Rutina Diaria'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oSN28Hij9m3o4sNE8qT6Qv/rakp4z7mx95dhy9.png',
  alt: 'Ejercicio - Encontrar las 5 Diferencias'
}];
export function SalesPage() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-brown" data-id="element-65">
      {/* Countdown Timer */}
      <CountdownTimer data-id="element-66" />

      {/* Top Bar */}
      <div className="bg-brand-gold-light text-brand-brown text-center py-2.5 text-sm font-black tracking-wide uppercase border-b border-brand-gold/30" data-id="element-67">
        ⚠️ OFERTA DE LANZAMIENTO POR TIEMPO LIMITADO ⚠️
      </div>

      {/* Hero Section */}
      <header className="py-12 px-4 md:py-20 bg-brand-cream" data-id="element-68">
        <div className="max-w-4xl mx-auto text-center" data-id="element-69">
          <div className="inline-block bg-brand-peach text-brand-coral-dark px-5 py-1.5 rounded-full font-black text-sm uppercase tracking-wider mb-6 transform -rotate-1 border border-brand-coral/20" data-id="element-70">
            Para niños de 4 a 8 años
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-brand-brown mb-8 leading-none" data-id="element-71">
            🧠 GIMNASIA CEREBRAL
            <br data-id="element-72" />
            INFANTIL
          </h1>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block relative w-full max-w-xl mx-auto mb-10 group" data-id="element-73">
            <img src={MAIN_IMAGE} alt="Mega Pack Gimnasia Cerebral Infantil" className="w-full h-auto rounded-2xl shadow-xl transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-74" />
          </a>

          <p className="text-xl md:text-2xl text-brand-brown-light font-medium mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-75">
            El sistema imprimible que mejora la atención y concentración en solo
            10 minutos al día (En casa o en el aula)
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-76">
            {['📘 100% IMPRIMIBLE', '⚡ Descarga inmediata', '🔓 Acceso de por vida'].map((text, i) => <span key={i} className="bg-white px-4 py-2 rounded-full font-bold text-brand-brown-light text-sm border border-brand-border shadow-sm" data-id="element-77">
                {text}
              </span>)}
          </div>

          <CTAButton subtext="Descarga Inmediata · Acceso de por vida" data-id="element-78">
            🟢 ¡SÍ, QUIERO EL MEGA PACK AHORA!
          </CTAButton>
        </div>
      </header>

      {/* Problem Section */}
      <section className="bg-brand-red-light py-16 px-4" data-id="element-79">
        <div className="max-w-3xl mx-auto" data-id="element-80">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-81">
            <AlertTriangle className="w-8 h-8 text-brand-red" data-id="element-82" />
            <h2 className="text-2xl md:text-3xl font-black uppercase text-brand-red" data-id="element-83">
              ¿Te suena familiar esto?
            </h2>
            <AlertTriangle className="w-8 h-8 text-brand-red" data-id="element-84" />
          </div>

          <div className="space-y-5 text-lg md:text-xl" data-id="element-85">
            {['Tus alumnos o hijos se distraen todo el tiempo…', 'Les cuesta terminar tareas…', 'Olvidan consignas constantemente…', 'El celular ya les ganó terreno…'].map((text, i) => <div key={i} className="bg-white p-5 rounded-lg border-l-4 border-brand-red shadow-sm" data-id="element-86">
                <p className="font-semibold text-brand-brown" data-id="element-87">⚠️ {text}</p>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-88">
            <p className="text-2xl md:text-3xl font-black text-brand-brown mb-4" data-id="element-89">
              No es falta de capacidad.{' '}
              <span className="text-brand-red underline decoration-4 underline-offset-4 decoration-brand-red" data-id="element-90">
                Es falta de entrenamiento cognitivo.
              </span>
            </p>
            <p className="text-xl text-brand-brown-light mt-4" data-id="element-91">
              Y eso se puede trabajar.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-16 px-4 bg-white" data-id="element-92">
        <div className="max-w-4xl mx-auto" data-id="element-93">
          <div className="text-center mb-12" data-id="element-94">
            <h2 className="text-3xl md:text-5xl font-black text-brand-brown mb-4 leading-tight" data-id="element-95">
              🚀 PRESENTAMOS EL MEGA PACK
              <br data-id="element-96" />
              <span className="text-brand-coral" data-id="element-97">
                GIMNASIA CEREBRAL INFANTIL
              </span>
            </h2>
            <p className="text-xl text-brand-brown-light" data-id="element-98">
              Un sistema estructurado en 5 módulos progresivos para fortalecer:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12" data-id="element-99">
            {['Atención sostenida', 'Memoria visual', 'Concentración', 'Razonamiento lógico', 'Coordinación visual', 'Estimulación cognitiva integral'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-brand-sage-light p-4 rounded-lg border border-brand-sage/20" data-id="element-100">
                <Check className="w-6 h-6 text-brand-sage flex-shrink-0" data-id="element-101" />
                <span className="font-bold text-brand-brown text-lg" data-id="element-102">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-8" data-id="element-103">
            {['📌 Listo para usar', '📌 Aplicable en casa y en primaria', '📌 Sin necesidad de experiencia previa'].map((item, i) => <span key={i} className="bg-brand-peach px-5 py-3 rounded-full font-bold text-brand-brown-light border border-brand-coral/10 text-sm" data-id="element-104">
                {item}
              </span>)}
          </div>

          <p className="text-center text-xl font-black text-brand-coral" data-id="element-105">
            No es entretenimiento. Es entrenamiento mental.
          </p>
        </div>
      </section>

      {/* Carousel - Preview Section */}
      <section className="py-16 px-4 bg-brand-peach" data-id="element-106">
        <div className="max-w-4xl mx-auto" data-id="element-107">
          <div className="text-center mb-10" data-id="element-108">
            <h2 className="text-3xl md:text-4xl font-black text-brand-brown mb-3" data-id="element-109">
              👀 Mirá el ebook por dentro
            </h2>
            <p className="text-lg text-brand-brown-light" data-id="element-110">
              Actividades reales del Mega Pack. Deslizá para ver más →
            </p>
          </div>

          <ImageCarousel images={CAROUSEL_IMAGES} data-id="element-111" />

          <div className="mt-10 max-w-3xl mx-auto" data-id="element-112">
            <CTAButton subtext="Descarga inmediata" data-id="element-113">
              🧠 ¡QUIERO ESTE MATERIAL!
            </CTAButton>
          </div>
        </div>
      </section>

      {/* Teachers & Parents Split */}
      <section className="py-16 px-4 bg-brand-cream" data-id="element-114">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-115">
          {/* Teachers */}
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-brand-sky" data-id="element-116">
            <div className="flex items-center gap-3 mb-6" data-id="element-117">
              <div className="bg-brand-sky-light p-3 rounded-full" data-id="element-118">
                <Users className="w-8 h-8 text-brand-sky" data-id="element-119" />
              </div>
              <h3 className="text-xl md:text-2xl font-black text-brand-brown" data-id="element-120">
                👩‍🏫 DOCENTES PRIMARIOS: ESTO ES PARA VOS
              </h3>
            </div>

            <p className="font-bold text-brand-brown-light mb-4" data-id="element-121">
              Sabemos que:
            </p>
            <ul className="space-y-3 mb-8 text-brand-brown-light" data-id="element-122">
              <li data-id="element-123">❌ El aula está cada vez más dispersa</li>
              <li data-id="element-124">❌ La tolerancia al esfuerzo es menor</li>
              <li data-id="element-125">❌ Las consignas deben repetirse varias veces</li>
              <li data-id="element-126">❌ La atención dura segundos</li>
            </ul>

            <div className="bg-brand-sky-light p-6 rounded-xl border border-brand-sky/20" data-id="element-127">
              <p className="font-bold text-brand-sky mb-4" data-id="element-128">
                Este Mega Pack te da:
              </p>
              <ul className="space-y-2" data-id="element-129">
                {['Actividades listas para fotocopiar', 'Material estructurado por niveles', 'Recursos para inicio de clase', 'Retos cognitivos progresivos', 'Herramientas concretas para mejorar rendimiento'].map((item, i) => <li key={i} className="flex items-start gap-2 text-brand-brown" data-id="element-130">
                    <Check className="w-5 h-5 text-brand-sky flex-shrink-0 mt-0.5" data-id="element-131" />
                    <span data-id="element-132">{item}</span>
                  </li>)}
              </ul>
            </div>
            <p className="mt-6 text-center font-black text-lg text-brand-coral" data-id="element-133">
              En 10 minutos diarios podés transformar el clima del aula.
            </p>
          </div>

          {/* Parents */}
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-brand-sage" data-id="element-134">
            <div className="flex items-center gap-3 mb-6" data-id="element-135">
              <div className="bg-brand-sage-light p-3 rounded-full" data-id="element-136">
                <Users className="w-8 h-8 text-brand-sage" data-id="element-137" />
              </div>
              <h3 className="text-xl md:text-2xl font-black text-brand-brown" data-id="element-138">
                👨‍👩‍👧 PADRES: SI QUERÉS RESULTADOS REALES
              </h3>
            </div>

            <p className="font-bold text-brand-brown-light mb-4" data-id="element-139">
              Este programa es ideal si:
            </p>
            <ul className="space-y-3 mb-8 text-brand-brown-light" data-id="element-140">
              {['Tu hijo se distrae fácilmente', 'Se frustra con tareas', 'Querés reducir pantallas', 'Querés estimular su mente sin presión'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-141">
                  <Check className="w-5 h-5 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-142" />
                  {item}
                </li>)}
            </ul>

            <div className="bg-brand-sage-light p-6 rounded-xl text-center border border-brand-sage/20" data-id="element-143">
              <Clock className="w-12 h-12 text-brand-sage mx-auto mb-3" data-id="element-144" />
              <p className="text-xl font-bold text-brand-sage" data-id="element-145">
                Solo necesitás 10 a 15 minutos por día.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 max-w-3xl mx-auto" data-id="element-146">
          <CTAButton subtext="Oferta de lanzamiento" data-id="element-147">
            🧠 ¡QUIERO EMPEZAR AHORA!
          </CTAButton>
        </div>
      </section>

      {/* Modules Section */}
      <section className="py-16 px-4 bg-white" data-id="element-148">
        <div className="max-w-4xl mx-auto" data-id="element-149">
          <h2 className="text-3xl md:text-5xl font-black text-center text-brand-brown mb-12" data-id="element-150">
            📦 ¿QUÉ INCLUYE?
          </h2>

          <div className="space-y-4 mb-12" data-id="element-151">
            {[{
            title: 'Módulo 1',
            desc: 'Atención y concentración',
            icon: Target
          }, {
            title: 'Módulo 2',
            desc: 'Memoria y observación',
            icon: Brain
          }, {
            title: 'Módulo 3',
            desc: 'Coordinación visual',
            icon: Zap
          }, {
            title: 'Módulo 4',
            desc: 'Asociación y lógica',
            icon: BookOpen
          }, {
            title: 'Módulo 5',
            desc: 'Retos cognitivos integrales',
            icon: ShieldCheck
          }].map((module, i) => <div key={i} className="flex items-center gap-4 p-5 border border-brand-border rounded-xl bg-brand-cream" data-id="element-152">
                <div className="bg-brand-coral text-white p-3 rounded-lg flex-shrink-0" data-id="element-153">
                  <module.icon className="w-6 h-6" data-id="element-154" />
                </div>
                <div data-id="element-155">
                  <span className="font-bold text-brand-coral uppercase text-sm" data-id="element-156">
                    🔹 {module.title}
                  </span>
                  <p className="font-bold text-brand-brown text-lg" data-id="element-157">
                    {module.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-brand-gold-light border border-brand-gold/30 rounded-xl p-6" data-id="element-158">
            <h3 className="text-xl font-black text-brand-brown mb-4" data-id="element-159">
              🎁 Además incluye:
            </h3>
            <ul className="space-y-2" data-id="element-160">
              {['Workbook de tarjetas visuales', 'Rutina semanal guiada', 'Juegos cognitivos sin pantallas', 'Registro de progreso'].map((item, i) => <li key={i} className="flex items-center gap-2 text-brand-brown font-medium" data-id="element-161">
                  <Check className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-162" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-brand-peach" data-id="element-163">
        <div className="max-w-5xl mx-auto" data-id="element-164">
          <div className="text-center mb-12" data-id="element-165">
            <span className="bg-brand-coral text-white px-6 py-2 rounded-full font-black uppercase tracking-widest text-sm mb-4 inline-block" data-id="element-166">
              🔥 Solo por lanzamiento
            </span>
            <h2 className="text-3xl md:text-5xl font-black mb-4 mt-4 text-brand-brown" data-id="element-167">
              🎁 BONOS EXCLUSIVOS GRATIS
            </h2>
            <p className="text-xl text-brand-brown-light" data-id="element-168">
              Llevate todo esto de regalo con tu compra hoy
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-169">
            <BonusCard title="Rutina Diaria de Gimnasia Cerebral" description="Guía práctica para padres y docentes. Uso en casa y en el aula." value="$12.000 ARS" imageSrc={BONO1_IMAGE} data-id="element-170" />
            <BonusCard title="Juegos Cognitivos Sin Pantallas" description="Actividades prácticas para estimular la mente infantil." value="$14.000 ARS" imageSrc={BONO2_IMAGE} data-id="element-171" />
            <BonusCard title="Registro de Progreso Cognitivo" description="Seguimiento de atención, memoria y concentración." value="$15.000 ARS" imageSrc={BONO3_IMAGE} data-id="element-172" />
          </div>

          <div className="max-w-3xl mx-auto" data-id="element-173">
            <CTAButton subtext="Incluye los 3 bonos GRATIS" data-id="element-174">
              🟢 QUIERO TODO AHORA
            </CTAButton>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-brand-cream" data-id="element-175">
        <div className="max-w-6xl mx-auto" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-black text-center text-brand-brown mb-12" data-id="element-177">
            ⭐ LO QUE DICEN QUIENES YA LO USAN
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-178">
            <TestimonialCard name="Gabriela M." role="Docente de 2do grado, Buenos Aires" content="En solo dos semanas noté cómo mis alumnos empezaron a mantener la atención por más tiempo. Las actividades son claras, progresivas y fáciles de aplicar." data-id="element-179" />
            <TestimonialCard name="Martín R." role="Padre de Tomás (6 años), Córdoba" content="Mi hijo pasaba horas con la tablet. Desde que empezamos con las actividades del Mega Pack, me pide él mismo los ejercicios. Mejoró su concentración y está más tranquilo." data-id="element-180" />
            <TestimonialCard name="Patricia L." role="Docente con 20 años de experiencia, Tucumán" content="En 20 años de docencia, nunca encontré un material tan bien organizado para trabajar la atención. Los módulos progresivos son exactamente lo que necesitaba." data-id="element-181" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-182">
            <TestimonialCard name="Soledad P." role="Docente de nivel inicial, Rosario" content="Lo mejor es que no necesitás preparar nada. Imprimís y listo. Mis nenes de sala de 5 lo disfrutan mucho y se nota el avance en la memoria visual." data-id="element-183" />
            <TestimonialCard name="Carolina D." role="Mamá de Valentina (5 años), Mendoza" content="Mi hija se frustraba con las tareas y no quería hacerlas. Con estos ejercicios empezó a ganar confianza. Ahora se concentra mucho mejor y hasta se divierte." data-id="element-184" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-185">
        <div className="max-w-3xl mx-auto text-center" data-id="element-186">
          <h2 className="text-3xl font-black text-brand-brown mb-8" data-id="element-187">
            ❓ ¿FUNCIONA?
          </h2>
          <p className="text-xl text-brand-brown-light mb-4" data-id="element-188">
            Sí. La atención y la memoria se entrenan con práctica estructurada.
          </p>
          <p className="text-2xl font-black text-brand-coral" data-id="element-189">
            No es magia. Es estimulación cognitiva aplicada.
          </p>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-16 px-4 bg-brand-cream" data-id="element-190">
        <div className="max-w-3xl mx-auto" data-id="element-191">
          <div className="bg-brand-sage-light border-2 border-brand-sage/30 rounded-2xl p-8 md:p-10 text-center" data-id="element-192">
            <Shield className="w-16 h-16 text-brand-sage mx-auto mb-4" data-id="element-193" />
            <h2 className="text-2xl md:text-3xl font-black text-brand-brown mb-4" data-id="element-194">
              🔒 GARANTÍA TOTAL DE 7 DÍAS
            </h2>
            <p className="text-lg text-brand-brown-light leading-relaxed" data-id="element-195">
              Si no ves avances en la atención y concentración, te devolvemos el{' '}
              <strong className="text-brand-brown" data-id="element-196">100% del dinero</strong>. Sin
              preguntas. Sin riesgos.
            </p>
          </div>
        </div>
      </section>

      {/* What if you do nothing */}
      <section className="py-16 px-4 bg-brand-red-light" data-id="element-197">
        <div className="max-w-3xl mx-auto text-center" data-id="element-198">
          <h2 className="text-2xl md:text-3xl font-black mb-8 text-brand-red" data-id="element-199">
            ❌ ¿Y SI NO HACÉS NADA?
          </h2>
          <div className="space-y-4 text-lg text-brand-brown-light" data-id="element-200">
            <p data-id="element-201">Más distracción. Más frustración.</p>
            <p data-id="element-202">Más dependencia de pantallas.</p>
            <p data-id="element-203">Más dificultades escolares.</p>
          </div>
          <div className="mt-8 pt-8 border-t border-brand-red/20" data-id="element-204">
            <p className="text-xl font-black text-brand-brown" data-id="element-205">
              El cerebro no entrenado se dispersa.
              <br data-id="element-206" />
              <span className="text-brand-sage" data-id="element-207">
                El cerebro entrenado mejora.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-16 px-4 bg-white" data-id="element-208">
        <div className="max-w-4xl mx-auto text-center" data-id="element-209">
          <h2 className="text-3xl md:text-5xl font-black text-brand-brown mb-10" data-id="element-210">
            🎯 IMAGINÁ ESTO
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-211">
            <div className="bg-brand-sky-light p-8 rounded-2xl border border-brand-sky/20 text-left" data-id="element-212">
              <h3 className="font-black text-xl mb-4 text-brand-sky" data-id="element-213">
                En el aula:
              </h3>
              <ul className="space-y-2" data-id="element-214">
                {['Más atención', 'Menos interrupciones', 'Mejor comprensión'].map((item, i) => <li key={i} className="flex items-center gap-2 text-brand-brown font-medium" data-id="element-215">
                    <Check className="w-5 h-5 text-brand-sky flex-shrink-0" data-id="element-216" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-brand-sage-light p-8 rounded-2xl border border-brand-sage/20 text-left" data-id="element-217">
              <h3 className="font-black text-xl mb-4 text-brand-sage" data-id="element-218">
                En casa:
              </h3>
              <ul className="space-y-2" data-id="element-219">
                {['Más foco', 'Más seguridad', 'Más autonomía'].map((item, i) => <li key={i} className="flex items-center gap-2 text-brand-brown font-medium" data-id="element-220">
                      <Check className="w-5 h-5 text-brand-sage flex-shrink-0" data-id="element-221" />
                      {item}
                    </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA / Pricing Section */}
      <section id="comprar" className="py-20 px-4 bg-brand-peach text-center relative overflow-hidden" data-id="element-222">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-223">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black mb-6 text-brand-coral leading-tight" data-id="element-224">
            🟢 ES MOMENTO DE ENTRENAR LA MENTE
          </h2>

          <p className="text-lg text-brand-brown-light mb-8" data-id="element-225">
            Mega Pack Gimnasia Cerebral Infantil
          </p>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block max-w-xs mx-auto mb-10" data-id="element-226">
            <img src={MAIN_IMAGE} alt="Mega Pack Gimnasia Cerebral Infantil" className="w-full h-auto rounded-2xl shadow-xl hover:scale-105 transition-transform" data-id="element-227" />
          </a>

          {/* Pricing Card */}
          <div className="bg-white text-brand-brown p-8 md:p-10 rounded-2xl max-w-2xl mx-auto shadow-xl mb-12 border-2 border-brand-coral" data-id="element-228">
            <div className="text-center mb-8" data-id="element-229">
              <p className="text-brand-brown-light text-lg line-through mb-1" data-id="element-230">
                Precio Regular: $49.990 ARS
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-231">
                <span className="text-brand-red font-black text-xl" data-id="element-232">
                  🔥 HOY SOLO
                </span>
              </div>
              <div className="text-5xl md:text-7xl font-black text-brand-coral leading-none mt-2" data-id="element-233">
                $19.990{' '}
                <span className="text-2xl text-brand-brown-light font-medium" data-id="element-234">
                  ARS
                </span>
              </div>
              <p className="text-brand-red font-bold mt-3 text-sm" data-id="element-235">
                ⏳ Precio promocional válido por lanzamiento. El valor volverá a
                $49.990 ARS sin previo aviso.
              </p>
            </div>

            <ul className="text-left space-y-3 mb-8 max-w-sm mx-auto" data-id="element-236">
              {['Acceso inmediato a los 5 módulos', 'Todos los bonos incluidos', 'Actualizaciones futuras gratis', '100% imprimible', 'Pago único', 'Acceso de por vida'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-237">
                  <Check className="w-5 h-5 text-brand-sage flex-shrink-0" data-id="element-238" />
                  <span className="font-medium text-brand-brown" data-id="element-239">{item}</span>
                </li>)}
            </ul>

            <CTAButton data-id="element-240">🧠 DESCARGÁ HOY EL MEGA PACK</CTAButton>

            <p className="text-xs text-brand-brown-light/60 mt-4 text-center" data-id="element-241">
              Pago único. Acceso de por vida. Garantía de 7 días.
            </p>
          </div>

          <div className="max-w-2xl mx-auto mb-12" data-id="element-242">
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="inline-block text-xl md:text-2xl font-black text-brand-coral underline underline-offset-4 decoration-brand-coral hover:text-brand-coral-dark transition-colors" data-id="element-243">
              👉 HACÉ CLIC Y EMPEZÁ AHORA
            </a>
          </div>

          <div className="space-y-4" data-id="element-244">
            <p className="text-lg text-brand-brown-light" data-id="element-245">
              Tu hijo no necesita más pantallas. Necesita entrenamiento mental.
            </p>
            <p className="text-xl font-bold text-brand-brown" data-id="element-246">
              Y eso empieza hoy.
            </p>

            <div className="pt-8 border-t border-brand-coral/20 mt-8" data-id="element-247">
              <h3 className="text-2xl md:text-4xl font-black text-brand-brown mb-3" data-id="element-248">
                🧠 MENOS PANTALLAS. MÁS CEREBRO ACTIVO.
              </h3>
              <p className="text-xl md:text-2xl text-brand-coral font-black tracking-widest uppercase" data-id="element-249">
                MÁS FOCO. MÁS RESULTADOS.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white text-brand-brown-light py-8 text-center text-sm border-t border-brand-border" data-id="element-250">
        <div className="max-w-4xl mx-auto px-4" data-id="element-251">
          <p data-id="element-252">
            © {new Date().getFullYear()} Impulso Digital. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-253">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}